import gql from 'graphql-tag';

export const mutationViewDokkioTag = gql`
  mutation viewDokkioTag (
    $id: DokkioID!
  ) {
    viewDokkioTag (
      id: $id
    )
  }
`;
export default mutationViewDokkioTag;
